import { Collection, } from "@bluelibs/x-ui";
import { Transaction } from "@root/api.types";
import { AppFilesCollection, } from "@bluelibs/x-ui-admin";
import { UsersCollection, CompaniesCollection, ExternalsCollection, BankAccountsCollection, } from "@bundles/UIAppBundle/collections";
export class TransactionsCollection extends Collection {
    getName() {
        return "Transactions";
    }
    getInputs() {
        return {
            insert: "TransactionInsertInput!",
            update: "TransactionUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
            {
                collection: () => CompaniesCollection,
                name: "company",
                field: "companyId",
            },
            {
                collection: () => ExternalsCollection,
                name: "external",
                field: "externalId",
            },
            {
                collection: () => BankAccountsCollection,
                name: "sourceBankAccount",
                field: "sourceBankAccountId",
            },
            {
                collection: () => BankAccountsCollection,
                name: "destinationBankAccount",
                field: "destinationBankAccountId",
            },
            {
                collection: () => AppFilesCollection,
                name: "transactionFiles",
                many: true,
                field: "transactionFilesIds",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
            transactionDate: (v) => (v && new Date(v) ? new Date(v) : v),
            dueDate: (v) => (v && new Date(v) ? new Date(v) : v),
            completeDate: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
